import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/work/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/data/work/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { login as _login, logout as _logout } from '@/api/user';
import { getToken, setToken, removeToken, removeUserInfo } from '@/utils/auth';
import router, { resetRouter } from '@/router';
var state = {
  token: getToken(),
  name: '',
  avatar: 'https://public.carlcare.com/public/c6070b51121599ebf62213889efe3a3f.png',
  introduction: '',
  roles: [],
  auth: [],
  authRoles: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = 'https://public.carlcare.com/public/c6070b51121599ebf62213889efe3a3f.png';
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_AUTH: function SET_AUTH(state, auth) {
    state.auth = auth;
  },
  SET_AUTH_ROLES: function SET_AUTH_ROLES(state, authRoles) {
    state.authRoles = authRoles;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password,
      verificationCode = userInfo.verificationCode,
      timeZoneID = userInfo.timeZoneID,
      uuid = userInfo.uuid;
    return new Promise(function (resolve, reject) {
      _login({
        username: username.trim(),
        password: password,
        verificationCode: verificationCode,
        timeZoneID: timeZoneID,
        uuid: uuid
      }).then(function (response) {
        var _ref2 = response || {},
          data = _ref2.data,
          code = _ref2.code,
          message = _ref2.message;
        if (+code === 200) {
          console.log('userInfo', data);
          var finalUserInfo = _objectSpread(_objectSpread({}, data), {}, {
            username: username.trim()
          });
          localStorage.setItem('userInfo', JSON.stringify(finalUserInfo));
          var roles = [data.account];
          commit('SET_TOKEN', data.token);
          commit('SET_ROLES', roles);
          var authStr = data.resource || '';
          if (data.faultCountry) authStr += ',' + data.faultCountry;
          if (data.deliveryCountry) {
            var deliveryArr = data.deliveryCountry.split(',').map(function (str) {
              return str.trim() + '1';
            });
            authStr += ',' + deliveryArr.join(',');
          }
          var authArr = authStr.split(',').filter(function (item) {
            return item && item.trim();
          }).map(function (str) {
            return str.trim();
          }).filter(function (item, index, arr) {
            return arr.indexOf(item) === index;
          });
          commit('SET_AUTH', authArr);
          commit('SET_NAME', data.account || username.trim());
          commit('SET_AUTH_ROLES', data.roles);
          setToken(data.token);
          resolve(finalUserInfo);
        } else {
          reject(new Error(message || '登录失败'));
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(function (resolve, reject) {
      var userInfoStr = localStorage.getItem('userInfo');
      if (!userInfoStr) {
        reject('用户信息不存在，请重新登录');
        return;
      }
      var userInfo = {};
      try {
        userInfo = JSON.parse(userInfoStr);
      } catch (e) {
        reject('用户信息解析错误');
        return;
      }

      // 🔥 必须保证 roles 存在
      if (!userInfo.roles) {
        userInfo.roles = ['admin'];
      }
      if (!userInfo.resource) {
        userInfo.resource = '';
      }
      if (userInfo.roles.includes('super')) {
        localStorage.setItem('pc_page', 'pc_active_import');
        localStorage.setItem('role', userInfo.roles[0]);
      } else {
        if (userInfo.activationManagementSoldBy && userInfo.activationManagementSoldBy.length > 0) {
          localStorage.setItem('activationManagementSoldBy', userInfo.activationManagementSoldBy);
        }
        if (userInfo.resource.includes('pc_page')) {
          localStorage.setItem('pc_page', userInfo.resource.includes('pc_active_import') ? 'pc_active_import' : 'pc_page_view');
        } else {
          localStorage.setItem('pc_page', '');
        }
      }
      var authStr = userInfo.resource || '';
      if (userInfo.faultCountry) authStr += ',' + userInfo.faultCountry;
      if (userInfo.deliveryCountry) {
        var deliveryArr = userInfo.deliveryCountry.split(',').map(function (str) {
          return str.trim() + '1';
        });
        authStr += ',' + deliveryArr.join(',');
      }
      var authArr = authStr.split(',').filter(function (item) {
        return item && item.trim();
      }).map(function (str) {
        return str.trim();
      }).filter(function (item, index, arr) {
        return arr.indexOf(item) === index;
      });
      commit('SET_AUTH', authArr);
      commit('SET_ROLES', [userInfo.account || userInfo.username]);
      commit('SET_NAME', userInfo.account || userInfo.username || 'user');
      commit('SET_AUTH_ROLES', userInfo.roles);
      resolve(userInfo);
    });
  },
  // user logout
  logout: function logout(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state,
      dispatch = _ref4.dispatch;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        removeToken();
        resetRouter();
        localStorage.removeItem('userInfo');
        removeUserInfo();
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      localStorage.removeItem('userInfo');
      removeUserInfo();
      resolve();
    });
  },
  changeRoles: function changeRoles(_ref6, role) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              setToken(token);
              _context.next = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context.sent;
              roles = _yield$dispatch.roles;
              resetRouter();
              _context.next = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context.sent;
              router.addRoutes(accessRoutes);
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};